import { Divider, Flex, Heading, Notice, Tag, Text } from '@applyboard/crystal-ui';
import { UpdateButtons } from "../UpdateButtons";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var approvalStatusText = {
  PENDING: 'New',
  IN_REVIEW: 'Under Review',
  APPROVED: 'Approved',
  DENIED: 'Rejected'
};
var approvalStatusIntent = {
  PENDING: 'primary',
  IN_REVIEW: 'warning',
  APPROVED: 'positive',
  DENIED: 'negative'
};
export var noticeText = {
  APPROVED: 'This account is approved',
  DENIED: 'This account is rejected',
  IN_REVIEW: 'This account is under review'
};
function StatusNotice(_ref) {
  var approvalStatus = _ref.approvalStatus;
  if (approvalStatus === 'PENDING') return null;
  return _jsx("div", {
    "data-testid": "status-notice",
    children: _jsx(Notice, {
      intent: approvalStatusIntent[approvalStatus],
      children: noticeText[approvalStatus]
    })
  });
}
function StatusTag(_ref2) {
  var approvalStatus = _ref2.approvalStatus;
  return _jsx("div", {
    "data-testid": "status-tag",
    children: _jsx(Tag, {
      intent: approvalStatusIntent[approvalStatus],
      size: "sm",
      children: approvalStatusText[approvalStatus]
    })
  });
}
var dateFormatter = new Intl.DateTimeFormat('en', {
  dateStyle: 'long',
  timeStyle: 'medium'
});
export function Header(_ref3) {
  var requestStatus = _ref3.requestStatus,
    ownerEmail = _ref3.ownerEmail,
    createdAt = _ref3.createdAt,
    updatedAt = _ref3.updatedAt,
    isUpdating = _ref3.isUpdating,
    onUpdate = _ref3.onUpdate,
    userLegacyId = _ref3.userLegacyId;
  return _jsxs(Flex, {
    as: "header",
    direction: "column",
    gap: 4,
    children: [_jsx(StatusNotice, {
      approvalStatus: requestStatus
    }), _jsxs(Flex, {
      direction: "column",
      gap: 2,
      children: [_jsxs(Flex, {
        direction: {
          xs: 'column',
          md: 'row'
        },
        justify: "between",
        children: [_jsx(Heading, {
          level: 1,
          variant: "headlineS",
          children: ownerEmail
        }), _jsx(UpdateButtons, {
          approvalStatus: requestStatus,
          onUpdate: onUpdate,
          isUpdating: isUpdating,
          userLegacyId: userLegacyId
        })]
      }), _jsxs(Flex, {
        gap: 4,
        justify: "start",
        direction: "row",
        children: [_jsx(Flex.Item, {
          children: _jsx(StatusTag, {
            approvalStatus: requestStatus
          })
        }), _jsx(Divider, {
          direction: "vertical"
        }), _jsx(Flex.Item, {
          children: _jsxs(Text, {
            contrast: "mid",
            children: ["Submitted: ", dateFormatter.format(createdAt)]
          })
        }), _jsx(Divider, {
          direction: "vertical"
        }), _jsx(Flex.Item, {
          grow: 1,
          children: _jsxs(Text, {
            contrast: "mid",
            children: ["Updated: ", dateFormatter.format(updatedAt)]
          })
        })]
      })]
    })]
  });
}